import { RouteConfig } from 'vue-router';

const Account = () => import('./views/account/account.vue');
const Role = () => import('./views/role/role.vue');
const ComposeUser = () => import('./views/compose-user/compose-user.vue');
const Hospital = () => import('./views/hospital/hospital.vue');


const routers: RouteConfig[] = [
    {
        path: 'account',
        component: Account,
    },
    {
        path: 'account-compose-user',
        component: ComposeUser,
    },
    {
        path: 'role',
        component: Role,
    },
    {
        path: 'hospital',
        component: Hospital,
    },
    {
        path: '',
        redirect: 'Account'
    },

]
export default routers;
